"use client";

import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { useAuthModal } from "@/components/auth/auth-modal-context";
import { cn } from "@/lib/utils";

/**
 * Ersetzt fuer Gaeste (kein Login) eine Funktion, die ein kostenloses Konto braucht
 * (Erik 2026-07-17: Watchlist-Speichern, Depot-Aenderungen, Alerts, PDF-Export) - statt
 * die Funktion einfach unsichtbar zu machen (`if (!userId) return null`), zeigt dieser
 * Button dieselbe Stelle weiter an, oeffnet aber beim Klick das Auth-Modal im
 * Signup-Modus mit einer konkreten, kontextspezifischen Begruendung statt der Funktion
 * selbst auszufuehren.
 */
export function AccountGateButton({
  reason,
  label,
  size = "icon",
  className,
  children,
}: {
  reason: string;
  label: string;
  size?: "icon" | "sm" | "lg";
  className?: string;
  children: ReactNode;
}) {
  const { openAuthModal } = useAuthModal();
  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      className={cn(size === "sm" && "gap-1.5", className)}
      aria-label={label}
      title={label}
      onClick={() => openAuthModal({ mode: "signup", reason })}
    >
      {children}
    </Button>
  );
}
